import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'printProfile', en);

const PrintProfileListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Print Options',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PRINT_PROFILE,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/print-profile/list',
      component: React.lazy(() => import('./PrintProfileList')),
    },
  ],
};

export default PrintProfileListConfig;
